import { Network } from '../../../utils/network'
import { Translate } from '../../../utils/translate'

import urls from './urls.json'

async function getBookmakerAccountDetails(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, data)
  return parsedResponse
}

async function sendRequest(data) {
  let url = urls.bookmakerDetails
  url = url.replace(/{bookmaker}/, data.service)
  let countryCode = await self.servicesVars.getUserCountryCode()
  countryCode = data.selectedCountry?.countryCode || countryCode
  const body = {
    playerId: data.accountId,
    service: '1xpay',
    currency: "xof"//countryCode == 'GA' ? 'xaf' : 'xof',
  }
  const response = await Network.sendRequestToWithRetries(url, body, 'post', 5)
  return response
}

function parseResponse(response, requestData) {
  if (
    response &&
    response.status.code === 200 &&
    response.response.data?.currency
  ) {
    const userId = response.response.data.userId
    const name = response.response.data.name.trim()
    let message = Translate.$t(
      'settingBettingIds.accountConfirmationTitle.withName',
      { name },
    )
    if (!name)
      message = Translate.$t(
        'settingBettingIds.accountConfirmationTitle.noName',
        { id: userId, bookmaker: requestData.service },
      )
    const data = {
      success: true,
      message,
      userId: userId,
      userName: name,
    }
    return data
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: Translate.$t('messages.badNetwork'),
      networkError: true,
    }
  }
  return {
    success: false,
    message: Translate.$t('settingBettingIds.incorrectId', {
      id: requestData.accountId,
      bookmaker: requestData.service,
    }),
  }
}

export { getBookmakerAccountDetails }
